import axios from 'axios';
import { PaginatedTechnologies } from '../types';

export const fetchTechnologiesList =
  async (): Promise<PaginatedTechnologies> => {
    return (await axios.get(`/v1/technology`)).data;
  };
